<div class="container">

    <!-- HEADER -->
    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 3 21 7l-4 4"/><path d="M21 7H9a4 4 0 0 0-4 4v1"/>
              <path d="M7 21 3 17l4-4"/><path d="M3 17h12a4 4 0 0 0 4-4v-1"/>
            </svg>
        </div>
        <div style="flex:1">
            <h1>Transferência entre Locais</h1>
            <p>Movimentação de estoque entre locais de armazenamento</p>
        </div>

        <!-- Ação no topo, mesmo padrão de pedido-venda/duplicar-produto -->
        <button type="button" class="btn-salvar-header"
                *ngIf="produtos().length > 0"
                [disabled]="itensSelecionados().length === 0 || !codLocalDestino()"
                (click)="validarTransferencia()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 3 21 7l-4 4"/><path d="M21 7H9a4 4 0 0 0-4 4v1"/>
              <path d="M7 21 3 17l4-4"/><path d="M3 17h12a4 4 0 0 0 4-4v-1"/>
            </svg>
            Executar Transferência
        </button>
    </div>

    <!-- LOADING -->
    <div *ngIf="loading()" class="loading-overlay">
        <app-loading-indicator></app-loading-indicator>
        <span class="loading-text">{{loadingMsg() || 'Carregando...'}}</span>
    </div>

    <!-- ============================== -->
    <!-- CARD: BUSCA RÁPIDA PRODUTO     -->
    <!-- ============================== -->
    <div class="card">
        <div class="card-title"> Busca Rápida por Produto</div>

        <div class="busca-wrapper" (click)="$event.stopPropagation()">
            <div class="busca-input-row">
                <input type="text"
                       [(ngModel)]="termoBusca"
                       (ngModelChange)="onTermoChange()"
                       placeholder="Digite o código, descrição ou Part Number..."
                       class="busca-input">
                <button class="btn secondary busca-clear"
                        *ngIf="termoBusca"
                        (click)="limparBusca()">✕</button>
            </div>

            <div class="busca-resultados" *ngIf="resultadosBusca().length > 0">
                <div class="busca-item"
                     *ngFor="let p of resultadosBusca()"
                     (click)="selecionarProdutoBusca(p)">
                    <div class="busca-item-main">
                        <span class="busca-cod">{{p.codprod || p.codigo}}</span>
                        <span class="busca-desc">{{p.descricao || p.nome}}</span>
                        <span class="busca-pn" *ngIf="p.refforn || p.partNumber">PN: {{p.refforn || p.partNumber}}</span>
                    </div>
                </div>
            </div>

            <div class="busca-empty" *ngIf="buscando()"><app-loading-indicator size="inline"></app-loading-indicator> Buscando...</div>
            <div class="busca-empty" *ngIf="!buscando() && termoBusca.length >= 3 && resultadosBusca().length === 0 && !mostrarLocaisProduto() && !produtoSelecionado">Nenhum produto encontrado</div>
            <div class="busca-empty" *ngIf="termoBusca.length > 0 && termoBusca.length < 3">Digite ao menos 3 caracteres...</div>

            <!-- Selecao de local quando produto tem estoque em varios locais -->
            <div class="locais-produto" *ngIf="mostrarLocaisProduto()">
                <div class="locais-produto-titulo">
                    📦 Produto encontrado em {{locaisProduto().length}} locais ➔ selecione o local de origem:
                </div>
                <div class="locais-produto-item"
                     *ngFor="let loc of locaisProduto()"
                     (click)="selecionarLocalDoProduto(loc)">
                    <span class="opt-code">{{loc.codLocal}}</span>
                    <span class="opt-desc">{{loc.descrLocal}}</span>
                    <span class="busca-estoque" style="margin-left:auto">Estoque: <strong>{{loc.estoque | number: casasDecimaisQtd(produtoSelecionado?.codvol, loc.estoque) :'pt-BR'}}</strong></span>
                </div>
            </div>
        </div>
    </div>

    <!-- ============================== -->
    <!-- CARD: SELEÇÃO DE LOCAIS        -->
    <!-- ============================== -->
    <div class="card">

        <div class="card-title">
            Selecionar Locais de Transferência
        </div>

        <div class="local-selector">

            <!-- ORIGEM -->
            <div class="field" (click)="$event.stopPropagation()">
                <label>
                    <span class="badge-local origem">ORIGEM</span>
                    Local de Saída
                </label>
                <div class="custom-select-wrapper">
                    <div class="custom-select-trigger"
                         [class.open]="dropOrigem()"
                         (click)="toggleDrop('origem')">
                        <span *ngIf="!codLocalOrigem()" class="placeholder">-- Selecione o local de origem --</span>
                        <span *ngIf="codLocalOrigem()">{{nomeLocalOrigem()}}</span>
                        <span class="arrow">▼</span>
                    </div>
                    <div class="custom-select-dropdown" *ngIf="dropOrigem()">
                        <div class="search-box">
                            <input type="text"
                                   [(ngModel)]="filtroOrigem"
                                   placeholder="Pesquisar local..."
                                   (click)="$event.stopPropagation()">
                        </div>
                        <div class="options-list">
                            <div class="option placeholder-opt"
                                 (click)="selecionarLocal('origem', null)">
                                -- Selecione o local de origem --
                            </div>
                            <div class="option"
                                 *ngFor="let loc of locaisOrigemFiltrados()"
                                 [class.selected]="loc.codLocal === codLocalOrigem()"
                                 (click)="selecionarLocal('origem', loc.codLocal)">
                                <span class="opt-code">{{loc.codLocal}}</span>
                                <span class="opt-desc">{{loc.descricao}}</span>
                            </div>
                            <div class="no-results"
                                 *ngIf="locaisOrigemFiltrados().length === 0">
                                Nenhum local encontrado
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="local-arrow-wrapper">
                <span class="local-arrow">➔</span>
            </div>

            <!-- DESTINO -->
            <div class="field" (click)="$event.stopPropagation()">
                <label>
                    <span class="badge-local destino">DESTINO</span>
                    Local de Entrada
                </label>
                <div class="custom-select-wrapper">
                    <div class="custom-select-trigger"
                         [class.open]="dropDestino()"
                         (click)="toggleDrop('destino')">
                        <span *ngIf="!codLocalDestino()" class="placeholder">-- Selecione o local de destino --</span>
                        <span *ngIf="codLocalDestino()">{{nomeLocalDestino()}}</span>
                        <span class="arrow">▼</span>
                    </div>
                    <div class="custom-select-dropdown" *ngIf="dropDestino()">
                        <div class="search-box">
                            <input type="text"
                                   [(ngModel)]="filtroDestino"
                                   placeholder="Pesquisar local..."
                                   (click)="$event.stopPropagation()">
                        </div>
                        <div class="options-list">
                            <div class="option placeholder-opt"
                                 (click)="selecionarLocal('destino', null)">
                                -- Selecione o local de destino --
                            </div>
                            <div class="option"
                                 *ngFor="let loc of locaisDestinoFiltrados()"
                                 [class.selected]="loc.codLocal === codLocalDestino()"
                                 (click)="selecionarLocal('destino', loc.codLocal)">
                                <span class="opt-code">{{loc.codLocal}}</span>
                                <span class="opt-desc">{{loc.descricao}}</span>
                            </div>
                            <div class="no-results"
                                 *ngIf="locaisDestinoFiltrados().length === 0">
                                Nenhum local encontrado
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

    <!-- ============================== -->
    <!-- CARD: LISTA DE PRODUTOS        -->
    <!-- ============================== -->
    <div class="card" *ngIf="produtos().length > 0">

        <div class="card-title">
            Produtos disponíveis no Local de Origem
        </div>

        <!-- STATUS BAR -->
        <div class="status-bar" *ngIf="itensSelecionados().length > 0">
            <span class="count">
                {{itensSelecionados().length}} item(ns) selecionado(s)
            </span>
            <span class="info">
                Preencha a quantidade desejada para transferir
            </span>
        </div>

        <!-- TABELA DESKTOP -->
        <div class="table-container hidden-mobile">
            <table>
                <thead>
                    <tr>
                        <th style="width:40px;">
                            <input type="checkbox" class="checkbox-custom" [(ngModel)]="selecionarTodos"
                                (change)="toggleTodos()">
                        </th>
                        <th>Código</th>
                        <th>Descrição</th>
                        <th>Part Number</th>
                        <th>Unid.</th>
                        <th>Controle</th>
                        <th>Estoque Disp.</th>
                        <th>Qtd. Transferir</th>
                        <th style="width:60px;">Imagem</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let prod of produtos()" [class.selecionado]="prod.selecionado">
                        <td><input type="checkbox" class="checkbox-custom" [(ngModel)]="prod.selecionado"></td>
                        <td>{{prod.codProd}}</td>
                        <td>{{prod.descricao}}</td>
                        <td>{{prod.partNumber || '-'}}</td>
                        <td>{{prod.codVol}}</td>
                        <td>{{prod.controle || '-'}}</td>
                        <td><strong>{{prod.estoque | number: casasDecimaisQtd(prod.codVol, prod.estoque) :'pt-BR'}}</strong></td>
                        <td>
                            <input type="number" class="input-qtd" [(ngModel)]="prod.qtdTransferir"
                                [disabled]="!prod.selecionado" min="1" [max]="prod.estoque" placeholder="0">
                        </td>
                        <td class="td-img">
                            <img class="img-thumb"
                                 [src]="prod.imagemSrc"
                                 [alt]="prod.descricao"
                                 (mouseenter)="showPreview($event, prod.imagemSrc || '', prod.codProd)"
                                 (mouseleave)="hidePreview()"
                                 (click)="abrirGaleria(prod)">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- CARDS MOBILE -->
        <div class="cards-mobile hidden-desktop">
            <div class="prod-card" *ngFor="let prod of produtos()"
                 [class.selecionado]="prod.selecionado"
                 (click)="prod.selecionado = !prod.selecionado">

                <div class="prod-card-header">
                    <input type="checkbox" class="checkbox-custom"
                           [(ngModel)]="prod.selecionado"
                           (click)="$event.stopPropagation()">
                    <img class="img-thumb-mobile"
                         [src]="prod.imagemSrc"
                         [alt]="prod.descricao"
                         (click)="$event.stopPropagation(); abrirGaleria(prod)">
                    <span class="prod-codigo">{{prod.codProd}}</span>
                    <span class="prod-vol">{{prod.codVol}}</span>
                    <span class="prod-estoque">Estoque: <strong>{{prod.estoque | number: casasDecimaisQtd(prod.codVol, prod.estoque) :'pt-BR'}}</strong></span>
                </div>

                <div class="prod-descricao">{{prod.descricao}}</div>

                <div class="prod-card-footer" *ngIf="prod.controle">
                    <span class="prod-controle-label">Controle:</span>
                    <span>{{prod.controle}}</span>
                </div>

                <div class="prod-qtd-row" *ngIf="prod.selecionado" (click)="$event.stopPropagation()">
                    <label>Qtd. a transferir:</label>
                    <input type="number" class="input-qtd"
                           [(ngModel)]="prod.qtdTransferir"
                           min="1" [max]="prod.estoque"
                           placeholder="0">
                </div>

            </div>
        </div>

    </div>

    <!-- ============================== -->
    <!-- EMPTY STATE                    -->
    <!-- ============================== -->
    <div class="card" *ngIf="codLocalOrigem() && produtos().length === 0 && !loading()">
        <div class="empty-state">
            <p>Nenhum produto com estoque encontrado neste local</p>
        </div>
    </div>

    <div class="card" *ngIf="!codLocalOrigem() && !loading()">
        <div class="empty-state">
            <p>Selecione um local de origem acima para visualizar os produtos</p>
        </div>
    </div>

    <!-- ============================== -->
    <!-- RESULTADO DA TRANSFERÊNCIA     -->
    <!-- ============================== -->
    <div class="resultado-card" *ngIf="resultado()">
        <h3>✔ Transferência Realizada com Sucesso!</h3>
        <div class="nota-info">
            <div class="nota-badge">
                <div>
                    <div class="label">Nota de Transferência</div>
                    <div class="numero">{{resultado()?.nuNota}}</div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- ============================== -->
<!-- MODAL DE CONFIRMAÇÃO           -->
<!-- ============================== -->
<div class="modal-overlay" *ngIf="mostrarModalConfirm()">
    <div class="modal-box">

        <div class="modal-header">
            ❓ Confirmar Transferência
        </div>

        <div class="modal-body">
            <p>Você está prestes a transferir
                <strong>{{itensSelecionados().length}}</strong>
                item(ns) do local
                <strong>{{nomeLocalOrigem()}}</strong>
                para o local
                <strong>{{nomeLocalDestino()}}</strong>.
            </p>
            <p>Essa operação irá gerar uma nota de saída e uma nota de
                entrada automaticamente. Deseja continuar?</p>
        </div>

        <div class="modal-footer">
            <button class="modal-btn cancel" (click)="cancelarTransferencia()">
                Cancelar
            </button>
            <button class="modal-btn confirm" (click)="executarTransferencia()">
                Confirmar
            </button>
        </div>

    </div>
</div>

<!-- Custom Notification Alert Modal -->
<div class="modal-overlay" *ngIf="alertaModal()">
    <div class="modal-box">
        <div class="modal-header" [ngClass]="alertaTipo()">
            <span *ngIf="alertaTipo() === 'sucesso'">✔ Sucesso</span>
            <span *ngIf="alertaTipo() === 'erro'">❌ Erro</span>
            <span *ngIf="alertaTipo() === 'aviso'">⚠ Aviso</span>
        </div>
        <div class="modal-body">
            <p>{{alertaTexto()}}</p>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharAlerta()">
                OK
            </button>
        </div>
    </div>
</div>

<!-- Preview global de imagem (fixed, fora da tabela) -->
<div id="img-preview-global" class="img-preview-global" [style.display]="previewVisible() ? 'block' : 'none'" [style.top]="previewTop" [style.left]="previewLeft">
    <img id="img-preview-global-img" [src]="previewSrc" alt="">
</div>

<!-- Galeria de imagens -->
<div class="img-modal-overlay" *ngIf="modalGaleria()" (click)="fecharGaleria()">
    <div class="img-modal-box" style="position:relative;" (click)="$event.stopPropagation()">

        <div class="galeria-titulo">{{galeriaDescricao}}</div>

        <div class="galeria-loading" *ngIf="galeriaCarregando()"><app-loading-indicator></app-loading-indicator> Carregando imagens...</div>

        <img *ngIf="!galeriaCarregando() && imagemAtual"
             class="img-modal-preview"
             [src]="imagemAtual" alt="">

        <div class="img-modal-actions">
            <div class="galeria-nav-inline" *ngIf="!galeriaCarregando() && listaImagens.length > 1">
                <button class="galeria-btn-nav" (click)="imagemAnterior()" [disabled]="indexImagem === 0">◀</button>
                <span class="galeria-counter">{{indexImagem + 1}} / {{listaImagens.length}}</span>
                <button class="galeria-btn-nav" (click)="proximaImagem()" [disabled]="indexImagem === listaImagens.length - 1">▶</button>
            </div>
            <button class="img-btn cancel" (click)="fecharGaleria()">Fechar</button>
        </div>

    </div>
</div>
